import React from 'react';
import { Calendar, CreditCard, Gift, Clock, Download, Send } from 'lucide-react';

const ProgramCards = ({ onOpenBrochure, onOpenEnquiry }) => {
  const programs = [
    {
      id: 'muj',
      university: 'Manipal University Jaipur',
      degree: 'Master of Business Administration',
      image: '/uploads/course-card-3.png',
      tags: ['13 Electives', 'Online MBA'],
      duration: '24 Months',
      oldFee: 'INR 7,500 / month',
      discountedFee: 'INR 6,375 / month',
      perks: 'Avail 15% early bird discount on course fee',
      closingDate: 'Admission closing on 3rd Sep!',
      brochureUrl: 'MUJ_MBA_Brochure.pdf',
      color: '#E55B00'
    },
    {
      id: 'mahe',
      university: 'Manipal Academy of Higher Education',
      degree: 'Master of Business Administration',
      image: '/uploads/course-card-2.png',
      tags: ['For Working Professionals', 'Online MBA', 'NIRF Rank 3 (2025)'],
      duration: '24 Months',
      oldFee: 'INR 12,167 / month',
      discountedFee: 'INR 11,711 / month',
      perks: 'Avail 15% scholarship for Women & Corporate Employees',
      closingDate: 'Admission closing on 3rd Sep!',
      brochureUrl: 'MAHE_MBA_Brochure.pdf',
      color: '#0056B3'
    },
    {
      id: 'smu',
      university: 'Sikkim Manipal University',
      degree: 'Master of Business Administration',
      image: '/uploads/course-card-1.png',
      tags: ['Dual Specialisation', 'Online MBA'],
      duration: '24 Months',
      oldFee: 'INR 5,000 / month',
      discountedFee: 'INR 4,500 / month',
      perks: '5 new-age industry aligned specializations',
      closingDate: 'Admission closing on 3rd Sep!',
      brochureUrl: 'SMU_MBA_Brochure.pdf',
      color: '#28A745'
    }
  ];

  return (
    <section className="program-cards-section" id="programs">
      <div className="section-header">
        <h2 className="section-title">
          Explore Our Online <span>MBA Programs</span>
        </h2>
        <p className="section-subtitle">
          Choose from top NAAC A+ accredited Manipal institutions tailored for career acceleration
        </p>
      </div>

      <div className="program-cards-grid">
        {programs.map((prog) => (
          <div className="program-card" key={prog.id}>
            <div className="card-image-wrapper">
              <img
                src={prog.image}
                alt={`${prog.university} - ${prog.degree}`}
                className="card-banner-img"
              />
              <div className="tags-overlay">
                {prog.tags.map((tag, idx) => (
                  <span className={`tag-chip ${idx === 0 ? 'highlight-tag' : ''}`} key={idx}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="card-body">
              <span className="university-label">{prog.university}</span>
              <h3 className="degree-title">{prog.degree}</h3>

              <div className="info-grid">
                <div className="info-item">
                  <Calendar size={18} className="info-font-icon" />
                  <div className="info-text">
                    <span className="info-label">Duration</span>
                    <span className="info-value">{prog.duration}</span>
                  </div>
                </div>

                <div className="info-item">
                  <CreditCard size={18} className="info-font-icon" />
                  <div className="info-text">
                    <span className="info-label">Fee (EMI Available)</span>
                    <div className="fee-box">
                      <del className="old-fee">{prog.oldFee}</del>
                      <span className="discount-fee">{prog.discountedFee}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="perks-banner">
                <Gift size={16} className="perks-font-icon" />
                <span>{prog.perks}</span>
              </div>

              <div className="date-highlight-ticker">
                <Clock size={15} color="#dc2626" />
                <span>{prog.closingDate}</span>
              </div>
            </div>

            <div className="card-footer">
              <button
                className="btn-card-brochure"
                onClick={() => onOpenBrochure(prog.university)}
              >
                <Download size={15} style={{ marginRight: '4px' }} /> Brochure
              </button>
              <button
                className="btn-card-enquire"
                onClick={() => onOpenEnquiry(prog.university)}
              >
                <Send size={15} style={{ marginRight: '4px' }} /> Enquire
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProgramCards;
